import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateTimeFormat',
})
export class DateTimeFormatPipe implements PipeTransform {
  transform(date: string): string {
    if (!date) return '';

    const formattedDateStr = date.replace(' ', 'T');
    const inputDate = new Date(
      formattedDateStr.includes('Z') ? formattedDateStr : formattedDateStr + 'Z'
    ); // Add 'Z' to indicate UTC time
    const today = new Date();
    const yesterday = new Date(today);
    yesterday.setDate(yesterday.getDate() - 1);
    const hours = this.formatHoursAndMinutes(inputDate);
    inputDate.setHours(0, 0, 0, 0);
    today.setHours(0, 0, 0, 0);
    yesterday.setHours(0, 0, 0, 0);

    if (inputDate.toString() === today.toString()) {
      return hours;
    } else if (inputDate.toString() === yesterday.toString()) {
      return 'Ayer';
    } else {
      return inputDate.toLocaleDateString();
    }
  }
  formatHoursAndMinutes(date: Date): string {
    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'pm' : 'am';

    hours = hours % 12;
    hours = hours ? hours : 12; // the hour '0' should be '12'

    const strHours = hours.toString().padStart(2, '0');
    const strMinutes = minutes.toString().padStart(2, '0');

    return `${strHours}:${strMinutes} ${ampm}`;
  }
}
